import { useState } from 'react';
import { KeyRound, Loader2 } from 'lucide-react';
import {
  ativarLicencaNaNuvem,
  formatarChaveDigitada,
} from '../../utils/barbeariaLicenca';

interface Props {
  onAtivado: () => void;
}

export default function BarbeariaLicencaAtivacao({ onAtivado }: Props) {
  const [chave, setChave] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  const enviar = async () => {
    setErro('');
    setCarregando(true);
    const r = await ativarLicencaNaNuvem(chave);
    setCarregando(false);
    if (!r.ok) {
      setErro(r.erro);
      return;
    }
    onAtivado();
  };

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center space-y-5 px-1">
      <div className="rounded-2xl border-2 border-neutral-800 bg-white p-6 shadow-sm">
        <div className="mb-4 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500 text-neutral-950">
            <KeyRound className="h-6 w-6" />
          </span>
          <div>
            <h1 className="text-lg font-black text-neutral-950">Ativar Carioca Barbershop</h1>
            <p className="text-xs font-medium text-neutral-600">
              Digite a chave que você recebeu na compra (1 aparelho).
            </p>
          </div>
        </div>

        <label className="mb-1 block text-xs font-bold text-neutral-800">Chave de acesso</label>
        <input
          type="text"
          value={chave}
          onChange={(e) => setChave(formatarChaveDigitada(e.target.value))}
          placeholder="CRCA-XXXX-XXXX-XXXX"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          className="mb-3 w-full rounded-xl border-2 border-neutral-400 bg-neutral-50 px-3 py-3 font-mono text-sm font-bold tracking-wider text-neutral-950 outline-none focus:border-amber-600"
          onKeyDown={(e) => {
            if (e.key === 'Enter') void enviar();
          }}
        />

        {erro && (
          <p className="mb-3 rounded-xl border border-red-700 bg-red-50 px-3 py-2 text-xs font-medium text-red-900">
            {erro}
          </p>
        )}

        <button
          type="button"
          disabled={carregando || chave.replace(/[^A-Z0-9]/g, '').length < 16}
          onClick={() => void enviar()}
          className="inline-flex w-full items-center justify-center gap-2 rounded-xl border-2 border-neutral-900 bg-amber-500 px-4 py-3 text-sm font-black text-neutral-950 disabled:opacity-50"
        >
          {carregando ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          Ativar neste aparelho
        </button>

        <p className="mt-4 text-[11px] leading-relaxed text-neutral-600">
          Precisa de internet só nesta ativação. Depois o app funciona offline. A chave fica
          vinculada a este celular/PC — para trocar de aparelho, peça liberação ao vendedor.
        </p>
      </div>
    </div>
  );
}
